<template>
	<div v-if="user">
		<div class="white-box">
			<div class="row row-in m-b-10">
				<div class="col-lg-3 col-sm-6 link" @click="$refs.settingsDocs.open()">
					<ul class="col-in">
						<li>
							<span class="circle circle-md bg-info">
								<i class="fa fa-file-text" aria-hidden="true"></i>
							</span>
						</li>
						<li class="col-middle">
							<h4>Documentos</h4>
						</li>
					</ul>
				</div>
				<div class="col-lg-3 col-sm-6 link" @click="$refs.settingsCustomers.open()">
					<ul class="col-in">
						<li>
							<span class="circle circle-md bg-info">
								<i class="fa fa-address-card-o" aria-hidden="true"></i>
							</span>
						</li>
						<li class="col-middle">
							<h4>Clientes</h4>
						</li>
					</ul>
				</div>
				<div class="col-lg-3 col-sm-6 link" @click="$refs.settingsAccount.open()">
					<ul class="col-in">
						<li>
							<span class="circle circle-md bg-info">
								<i class="fa fa-user-circle" aria-hidden="true"></i>
							</span>
						</li>
						<li class="col-middle">
							<h4>Cuenta</h4>
						</li>
					</ul>
				</div>
				<div class="col-lg-3 col-sm-6 link" @click="$refs.settingsGeneral.open()">
					<ul class="col-in">
						<li>
							<span class="circle circle-md bg-info">
								<i class="fa fa-cogs" aria-hidden="true"></i>
							</span>
						</li>
						<li class="col-middle">
							<h4>General</h4>
						</li>
					</ul>
				</div>
			</div>
			<div class="row row-in">
				<div class="col-lg-3 col-sm-6 link" @click="$refs.settingsProducts.open()">
					<ul class="col-in">
						<li>
							<span class="circle circle-md bg-info">
								<i class="fa fa-cube" aria-hidden="true"></i>
							</span>
						</li>
						<li class="col-middle">
							<h4>Productos</h4>
						</li>
					</ul>
				</div>
				<div class="col-lg-3 col-sm-6">
					<router-link to="settings/paymentconditions">
						<ul class="col-in">
							<li>
								<span class="circle circle-md bg-info">
									<i class="fa fa-money" aria-hidden="true"></i>
								</span>
							</li>
							<li class="col-middle">
								<h4>Condiciones de pago</h4>
							</li>
						</ul>
					</router-link>
				</div>
				<div class="col-lg-3 col-sm-6 link" @click="$refs.termsAndConditions.open()">
					<ul class="col-in">
						<li>
							<span class="circle circle-md bg-info">
								<i class="fa fa-handshake-o" aria-hidden="true"></i>
							</span>
						</li>
						<li class="col-middle">
							<h4>Términos y condiciones</h4>
						</li>
					</ul>
				</div>
				<div class="col-lg-3 col-sm-6 link" @click="$refs.apiKeys.open()">
					<ul class="col-in">
						<li>
							<span class="circle circle-md bg-info">
								<i class="fa fa-key" aria-hidden="true"></i>
							</span>
						</li>
						<li class="col-middle">
							<h4>API KEYS</h4>
						</li>
					</ul>
				</div>
			</div>
		</div>

		<docs
			ref="settingsDocs"
			:user="user"
			:isAuth="isAuth">
		</docs>
		<account
			ref="settingsAccount"
			:user="user"
			:isAuth="isAuth">
		</account>
		<customers
			ref="settingsCustomers"
			:user="user"
			:isAuth="isAuth">
		</customers>
		<general
			ref="settingsGeneral"
			:user="user"
			:isAuth="isAuth">
		</general>
		<products
			ref="settingsProducts"
			:user="user"
			:isAuth="isAuth">
		</products>
		<terms-and-conditions
			ref="termsAndConditions"
			:user="user"
			:isAuth="isAuth">
		</terms-and-conditions>
		<api-keys
			ref="apiKeys"
			:user="user"
			:isAuth="isAuth">
		</api-keys>
	</div>
</template>

<script>
	import Docs from './Docs'
	import Account from './Account'
	import Customers from './Customers'
	import General from './General'
	import Products from './Products'
	import TermsAndConditions from './TermsAndConditions'
	import ApiKeys from './ApiKeys'
	
	export default {
		props: ['user', 'isAuth'],
		components: {
			'docs': Docs,
			'account': Account,
			'customers': Customers,
			'general': General,
			'products': Products,
			'terms-and-conditions': TermsAndConditions,
			'api-keys': ApiKeys,
		},
		data () {
			return {
			}
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/settings/views/Index.vue